import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {cusWjw,cusWjws,cusWjwByEvent,cusWjwMake,cusWjwMakeReport,cusWjwMakeTotalReport,cusWjwMakeExp} = api

/**
 * 查找
 */
export async function findCusWjw(params) {
    return request({url: cusWjw, method: 'get', data: params,})
}
export async function findCusWjwByEvent(params) {
    return request({url: cusWjwByEvent, method: 'get', data: params,})
}
export async function findCusWjws(params) {
    return request({url: cusWjws, method: 'get', data: params,})
}
/**
 * 查找列表
 */
export async function findCusWjwMake(params) {
    return request({url: cusWjwMake, method: 'get', data: params,})
}
/**
 * 添加
 */
export async function createCusWjws(params) {
    return request({url: cusWjws, method: 'post', data: params,})
}
/**
 * 更新
 */
export async function updateCusWjw(params) {
    return request({url: cusWjw, method: 'put', data: params,})
}
/**
 * 更新
 */
export async function deleteCusWjw(params) {
    return request({url: cusWjw, method: 'delete', data: params,})
}
/**
 * 查找
 */
export async function findCusWjwReport(params) {
    return request({url: cusWjwMakeReport, method: 'get', data: params,})
}
export async function findCusWjwTotalReport(params) {
    return request({url: cusWjwMakeTotalReport, method: 'get', data: params,})
}
/**
 * 导出
 */
export async function expCusWjw(params) {
    return request({url: cusWjwMakeExp, method: 'get', data: params,})
}





// WEBPACK FOOTER //
// ./src/services/customization.js